export const getYara = {
  pathname: (id) => `/api/v4/malware/${id}/yara`,
}

export const download = {
  pathname: '/api/v4/yara/download',
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/zip'
  },
  method: 'POST',
  body: (ids) => ({ malware_ids: ids })
}
